export default "__VITE_ASSET__R7o$f3eD__"